// src/pages/PaymentReturnSubscription.jsx
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function PaymentReturnSubscription() {
  const [sp] = useSearchParams();
  const intentId = sp.get("intent") || sp.get("identifier") || "";
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let t;
    const run = async () => {
      if (!intentId) return setStatus("missing");
      // on “poll” l’intent 2-3 fois le temps que le webhook passe
      for (let i = 0; i < 6; i++) {
        const snap = await getDoc(doc(db, "paymentIntents", intentId));
        if (snap.exists()) {
          const s = snap.data()?.status;
          if (s === "paid") return setStatus("paid");
          if (String(s).startsWith("failed") || s === "expired") return setStatus(s);
        }
        await new Promise((r) => (t = setTimeout(r, 1500)));
      }
      setStatus("pending");
    };
    run();
    return () => clearTimeout(t);
  }, [intentId]);

  return (
    <div className="container py-4">
      <h3>Paiement abonnement</h3>

      {status === "paid" ? (
        <div className="alert alert-success">
          Paiement confirmé ✅ Votre Pack Pro est actif.
        </div>
      ) : status === "missing" ? (
        <div className="alert alert-danger">Identifiant de paiement manquant.</div>
      ) : status === "expired" ? (
        <div className="alert alert-warning">Paiement expiré. Recommencez.</div>
      ) : String(status).startsWith("failed") ? (
        <div className="alert alert-danger">
          Paiement non validé ({status}). Si vous avez payé, contactez l’admin.
        </div>
      ) : (
        <div className="alert alert-info">
          Vérification du paiement… (cela peut prendre quelques secondes)
        </div>
      )}

      <Link to="/vendor/abonnement" className="btn btn-primary btn-sm">
        Retour à l’abonnement
      </Link>
    </div>
  );
}
